import { useEffect, useState } from 'react'
import { apiUrl } from 'constants/api';
import useFetch from 'hooks/useFetch';
import Heading from 'components/common/Heading';
import Modal from 'components/common/Modal';

import BookData from 'components/BookCard/BookMoreInfoModal/BookData';

const BookMoreinfoModal = ({ setShowModal, isbn }) => {
    const [bookData, setBookData] = useState(null);
    const { data, loading } = useFetch({
        url: isbn ? `${apiUrl}/api/books?bibkeys=ISBN:${isbn}&jscmd=details&format=json` : false
    });
    
    const closeModal = () => setShowModal(false);

    useEffect(() => {
        if(data) {
            setBookData(Object.values(data)[0]?.details)
        }
    }, [data]);

    return (
        <Modal closeModal={closeModal}>
            <div className="p-5" style={{ width: '50vw' }}>
                <section>
                    <Heading styledAs="h3">
                        2c. Display additional info when hovering the book
                    </Heading>

                    <ul>
                        <li>
                            When hovering over the book display full info about the book in the overlay (big image, title, authors, publish date, physical format, number_of_pages, weight)
                        </li>
                        <li>
                            Notes:
                            Books can have multiple ISBNs, just take the first for the call
                        </li>
                    </ul>
                </section>

                <hr className="my-4" />

                { loading ? (
                    <h2>Loading book data</h2>
                ) : (
                    bookData && <BookData data={bookData} />
                )}
            </div>
        </Modal>
    )
}

export default BookMoreinfoModal